<template>
  <section class="section">
    <div class="container">
      <h2 class="section-title">为什么选择海曦云游戏</h2>
      <p class="section-lead">从技术到服务，我们为您提供全方位的竞争优势</p>
      <div class="benefits-list">
        <article v-for="(b, i) in benefits" :key="b.title" class="benefit-card">
          <span class="benefit-watermark" aria-hidden="true">{{ i + 1 }}</span>
          <h3>{{ b.title }}</h3>
          <p>{{ b.desc }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const benefits = [
  { title: '快速上线', desc: '标准化接入流程，最快 2 周完成集成部署。提供完善的开发文档和技术支持，降低开发成本。' },
  { title: '成本可控', desc: '按需付费，无需前期大量硬件投入。GPU 资源池化共享，显著降低单用户算力成本。' },
  { title: '画质无损', desc: '支持 4K/120fps、HDR、光线追踪等次世代画质特性，云端渲染画质媲美本地高端 PC。' },
  { title: '全国覆盖', desc: '全国32省/自治区/直辖市边缘云游戏服务覆盖，三大运营商智能就近接入，提供最高4k120Hz，最低RTT延迟至5ms的电竞级游戏体验。' },
  { title: '弹性扩展', desc: '支持秒级自动扩缩容，轻松应对新游上线、活动促销等突发流量高峰，无需担心容量瓶颈。' },
  { title: '专业支持', desc: '7×24 小时技术支持团队，提供架构咨询、性能调优、故障排查等全方位服务，保障业务稳定运行。' }
];
</script>
